import script from "./TermList.vue?vue&type=script&setup=true&lang=js"
export * from "./TermList.vue?vue&type=script&setup=true&lang=js"

import "./TermList.vue?vue&type=style&index=0&id=54d54f4f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d54f4f"]])

export default __exports__